import { onMounted, reactive, toRefs, watch, unref, Vue2 } from 'vue-demi'
import service from '@/service/correction'
import { useTable } from '@/utils/commonUse'
// import { getToken } from '@/utils/tools'
/**
 * @description 获取讲次列表
 * @param {筛选课程列表所需参数} param
 * @returns
 */
export function useGetLessonList (selectedGroup, refs) {
  const state = reactive({
    lessonTableLoading: false,
    // 课程列表数据
    lessonList: []
  })
  const { scroll, getScroll } = useTable()
  /**
   * @description 获取课程列表
   */
  const getLessonList = (isRefresh = false, groupList) => {
    if (!selectedGroup.value) {
      state.lessonList = []
      return
    }
    state.lessonTableLoading = true
    const { id, classTypeId } = selectedGroup.value
    const httpParam = {
      xkhTeacherCourseId: id,
      classTypeId
    }
    // 接口出错
    const afterError = res => {
      // 该小组已不在你名下
      if (res && res.errorCode === 31001) {
        // 将小组从列表中删除
        groupList.value.splice(selectedGroup.value.index, 1)
        groupList.value = groupList.value.map((item, index) => ({
          ...item,
          index
        }))
        console.log(groupList.value)
        // 默认选中第一个
        selectedGroup.value = groupList.value[0]
      }
      // 出错，清空讲次列表
      // state.lessonList = []
    }
    // 接口完成
    const afterFinally = () => {
      state.lessonTableLoading = false
    }
    if (isRefresh) {
      // 如果是刷新讲次，走刷新的逻辑
      return service.getLessonRefreshList(httpParam).then(res => {
        const { lessonList, courseInfo } = res
        state.lessonList = lessonList || []
        const tableDom = refs.table.$el
        Vue2.nextTick(() => getScroll(tableDom))
        // 更新班型信息
        groupList.value[selectedGroup.value.index] = {
          ...selectedGroup.value,
          ...courseInfo
        }
      }).catch(afterError).finally(afterFinally)
    }
    return service.getLessonList(httpParam).then(res => {
      state.lessonList = res || []
      const tableDom = refs.table.$el
      Vue2.nextTick(() => getScroll(tableDom))
    }).catch(afterError).finally(afterFinally)
  }

  watch(() => selectedGroup.value, val => {
    getLessonList()
  })

  return {
    ...toRefs(state),
    scroll,
    getLessonList
  }
}

/**
 * @description 获取小组列表
 * @param {课程id} param
 */
export function useGetGroupList(params, selectedGroup) {
  // 小组分页数据
  const state = reactive({
    groupPagination: {
      current: 1,
      pageSize: 50,
      totalPage: 0
    },
    // 小组数据
    groupList: [],
    groupListLoading: false
  })
  /**
   * @description 获取小组列表
   */
  const getGroupList = () => {
    const { current: pageNum, pageSize } = state.groupPagination
    const { groupName, year, period, classCycles, timeIntervals } = params
    const yearAndSemester = year ? year.split(' ') : ['', '']
    console.log('yearAndSemester', yearAndSemester)
    const param = {
      pageNum,
      pageSize,
      groupName,
      period,
      classCycles,
      timeIntervals,
      year: yearAndSemester[0],
      semester: yearAndSemester[1]
    }
    state.groupListLoading = true
    return service.getGroupList(param).then(res => {
      const { list, itemTotal } = res
      state.groupList = list.map((item, index) => ({ ...item, index }))
      state.groupPagination.totalPage = itemTotal
      if (state.groupList.length < 1) return
      // 如果没有选中项，设置第一个为选中项
      if (!unref(selectedGroup)) {
        const [firstItem] = state.groupList
        selectedGroup.value = firstItem
      } else {
        const record = state.groupList.find(item => item.id === selectedGroup.value.id)
        if (record) {
          selectedGroup.value = record
        }
      }
    }).catch().finally(() => {
      state.groupListLoading = false
    })
  }
  onMounted(() => {
    // if (!getToken()) return
    // getGroupList()
  })
  watch([() => state.groupPagination.current], () => {
    getGroupList()
  })
  return {
    ...toRefs(state),
    getGroupList
  }
}

/**
 * @description 获取题解视频列表
 * @param {classTypeId, lessonId} param
 */
export function findTeacherExplainVedio(data) {
  return service.findTeacherExplainVedio(data)
}